/**
 * 商品模块store数据
 */
const state = {
  customProduct: null, // 定制商品信息（从商品详情页传递到新增定制商品页）
  touristAddCustom: null, // 官网游客新增的定制商品
  productDetailSimilar: []// 商品详情跳转以图搜图存储
}

const mutations = {
  set(state, object) {
    Object.assign(state, object)
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
